import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
 
/** 
 * html2canvas makes a clone of the passed HTML on a canvas,
 * takes a screen shot of the canvas, and produces an image. Jspdf creates the pdf.
 * I set canvas dimensions, window dimensions, and content dimensions to 8.5 x 11 inches
 * (converted to pixels).
 *
 * PDFs scaled to 1 are blurry, so we need to scale up to improve image quality.
 * Scaling also requires increasing final PDF dimensions
 *
 * IMPORTANT to set jspdf option compress to true, to prevent generating MASSIVE pdfs (at any scale).
 * 
 * @param {Node} ref the parent node of our checklist component
 * @param {String} fileName to name the returned pdf
 * @param {function} callback performs any cleanup or state update after pdf loads/fails to load. 
 * (e.g., sets download pdf button loading state to false)
 * @returns {undefined} 
 */
export const generatePDF = (ref, fileName, callback) => {
    const content = ref.current;
    html2canvas(content, {
        logging: false,
        windowWidth: 816,
        windowHeight: 1056,
        width: 816,
        height: 1056,
        scale: 2,
        onclone: function (clonedDoc) {
            // adding parent class allows checklist to be styled as printable
            clonedDoc.querySelector(".checklist").parentNode.classList.add("printable-checklist");
            // expand any collapsed accordion item so can be printed
            clonedDoc.querySelectorAll(".checklist-ingka-accordion__item").forEach((item) => {
                item.classList.add("checklist-ingka-accordion__item--active");
            });
            // the html2canvas library replaces psuedoelements with a custom element
            // and applies inline styles to those custom elements. for collapsed
            // accordions, the custom elements are styled to hidden visibility.
            // An override is necessary
            clonedDoc.querySelectorAll("html2canvaspseudoelement").forEach((item) => {
                item.style.visibility = "visible";
            });
        }
    })
        .then((canvas) => {
            const imgData = canvas.toDataURL("image/png", 1);
            const pdf = new jsPDF({ orientation: "portrait", unit: "in", format: [17, 22], compress: true });
            pdf.addImage(imgData, "PNG", 0, 0);
            pdf.save(fileName);
            callback();
        })
        .catch((error) => {
            console.error(error);
            callback();
        });
};

